module.exports = __webpack_public_path__ + "images/img-1CgyFp4.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/managers/50.jpg
// module id = 2011
// module chunks = 0